module.exports = __webpack_public_path__ + "static/img/testDefault.021de12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testDefault.png
// module id = V0Yy
// module chunks = 156